import { Button, HStack, Image, Input, InputGroup, InputRightElement, Text, VStack, useToast, Flex, Box, useColorModeValue, Icon, Heading, SimpleGrid, IconButton } from '@chakra-ui/react';
import React, { useContext, useEffect, useRef, useState } from 'react'
import { AppContext } from '../../../context/AppContext';
import { GetAllCurrency, SubmitTransactionAPI } from '../../../utils/api';
import { FiCopy, FiCheckCircle, FiArrowLeft } from "react-icons/fi";
import { BsCurrencyBitcoin } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import trxIcon from '../../../assets/trx.png';
import usdtIcon from '../../../assets/tether.png';
const Crypto = () => {
  const { Token, setBalance } = useContext(AppContext);
  const toast = useToast();
  const [currentService, setCurrentService] = useState({});
  const [data, setData] = useState([]);
  const inputRef = useRef();
  const [hasCopied, setHasCopied] = useState(false);
  const navigate = useNavigate();

  // Premium UI Colors
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const textColor = useColorModeValue("gray.800", "white");
  const subTextColor = useColorModeValue("gray.500", "gray.400");
  const inputBg = useColorModeValue("gray.50", "gray.700");
  const hoverBg = useColorModeValue("gray.50", "whiteAlpha.100");

  useEffect(() => {
    GetAllCurrency(Token).then((res) => {
      setData(res.data.data);
      console.log(res.data.data);
    }).catch((err) => {
      console.log(err, 'error saying');
    });
  }, []);

  const CopyToClipBoard = () => {
    navigator.clipboard
      .writeText("TUcSg8G1kMbpQjEYMxRhTeA7oFJrYiQHkG")
      .then(() => {
        setHasCopied(true);
        toast({
          status: "info",
          title: `Address copied`,
          isClosable: true,
          duration: 1000,
          position: "bottom-right",
        });
        setTimeout(() => setHasCopied(false), 2000);
      })
      .catch((error) => {
        console.error("Failed to copy text: ", error);
        toast({
          status: "error",
          title: `errror in copying address`,
          isClosable: true,
          duration: 1000,
        });
      });
  };

  const handleTransaction = () => {
    if (inputRef.current.value == "") {
      toast({
        status: "warning",
        title: "Please Enter Transaction Id",
        isClosable: true,
        duration: 1000,
      });
      return;
    }
    SubmitTransactionAPI(Token, { transactionId: inputRef.current.value, method: 'crypto' })
      .then((res) => {
        console.log(res.data, "successfull");
        setBalance(res.data.balance);
        toast({
          title: "Congratulations 🎊",
          status: "success",
          description: `Your ${res.data.transaction.amount}rs is successfully added`,
          isClosable: true,
          duration: 4000,
        });
        inputRef.current.value = "";
      })
      .catch((err) => {
        toast({
          status: "error",
          title: err.response?.data.message,
          isClosable: true,
        });
        console.log(err, "saying error");
      });
  };

  return (
    <VStack w="100%" spacing={8} align="center" py={8}>
      {/* ===== COMING SOON BANNER ===== */}
      <Box
        bg={cardBg}
        border="1px solid"
        borderColor={borderColor}
        rounded="2xl"
        shadow="lg"
        p={{ base: 8, md: 10 }}
        w={{ base: "100%", md: "560px" }}
        maxW="100%"
        textAlign="center"
      >
        <VStack spacing={5}>
          {/* Animated Icon */}
          <Flex
            align="center"
            justify="center"
            bg="orange.50"
            p={5}
            rounded="full"
            color="orange.400"
            boxSize="80px"
            mx="auto"
          >
            <Icon as={BsCurrencyBitcoin} boxSize={10} />
          </Flex>

          {/* Heading */}
          <Heading size="lg" color={textColor} fontWeight="700">
            Crypto Payments
          </Heading>

          {/* Coming Soon Badge */}
          <Flex
            display="inline-flex"
            align="center"
            gap={2}
            bg="orange.100"
            color="orange.600"
            px={4}
            py={1.5}
            rounded="full"
            fontSize="xs"
            fontWeight="700"
            letterSpacing="widest"
            textTransform="uppercase"
          >
            🚀 Coming Soon
          </Flex>

          {/* Description */}
          <Text color={subTextColor} fontSize="sm" lineHeight="tall" maxW="380px">
            We're working hard to bring you seamless crypto payments.
            Soon you'll be able to recharge using <strong>USDT</strong>, <strong>TRX</strong>, and more — fast, secure, and decentralised.
          </Text>

          {/* Divider line */}
          <Box w="60px" h="3px" bg="orange.300" rounded="full" />

          {/* Footer note */}
          <Text fontSize="xs" color={subTextColor}>
            Stay tuned for updates. We'll notify you as soon as it's live! 🎉
          </Text>
        </VStack>
      </Box>

      {/* ===== ORIGINAL UI (commented out — re-enable when crypto feature is ready) =====

      <Box
        bg={cardBg}
        border="1px solid"
        borderColor={borderColor}
        rounded="2xl"
        shadow="lg"
        p={{ base: 6, md: 8 }}
        w={{ base: "100%", md: "600px" }}
        maxW="100%"
      >
        <VStack spacing={6}>
          <VStack spacing={2}>
            <Flex
              align="center"
              justify="center"
              bg="orange.50"
              p={3}
              rounded="full"
              color="orange.500"
              mb={2}
            >
              <Icon as={BsCurrencyBitcoin} boxSize={6} />
            </Flex>
            <Heading size="md" color={textColor}>Crypto Payment</Heading>
            <Text color={subTextColor} fontSize="sm" textAlign="center">
              Select a cryptocurrency to proceed with payment
            </Text>
          </VStack>

          <SimpleGrid columns={{ base: 2, sm: 3 }} spacing={4} w="100%">
            {data?.map((el) => (
              <Button
                key={el._id}
                h="auto"
                py={4}
                variant="outline"
                borderColor={currentService._id === el._id ? (el.color || 'brand.500') : borderColor}
                bg={currentService._id === el._id ? `${el.color}10` : 'transparent'}
                _hover={{
                  borderColor: el.color || 'brand.500',
                  bg: `${el.color}10`
                }}
                onClick={() => setCurrentService(el)}
                display="flex"
                flexDirection="column"
                gap={2}
                rounded="xl"
                borderWidth="2px"
              >
                <Image
                  src={el.currencyName=='TRX'? trxIcon: usdtIcon}
                  w="32px"
                  h="32px"
                  alt={el.currencyName}
                />
                <Text fontWeight="bold" fontSize="sm" color={textColor}>
                  {el.currencyName}
                </Text>
              </Button>
            ))}
          </SimpleGrid>

          {currentService.currencyName && (
            <VStack w="100%" spacing={6} align="stretch" pt={4} borderTop="1px solid" borderColor={borderColor}>
              <Box>
                <Text mb={2} fontWeight="600" fontSize="sm" color={textColor}>Wallet Address ({currentService.currencyName})</Text>
                <InputGroup size="lg">
                  <Input
                    value="TUcSg8G1kMbpQjEYMxRhTeA7oFJrYiQHkG"
                    readOnly
                    bg={inputBg}
                    border="1px solid"
                    borderColor={borderColor}
                    _focus={{ borderColor: currentService.color || "brand.500" }}
                    fontSize="sm"
                    fontFamily="monospace"
                  />
                  <InputRightElement width="4.5rem">
                    <Button
                      h="1.75rem"
                      size="sm"
                      onClick={CopyToClipBoard}
                      colorScheme={hasCopied ? "green" : "gray"}
                      variant={hasCopied ? "solid" : "ghost"}
                    >
                      {hasCopied ? <Icon as={FiCheckCircle} /> : <Icon as={FiCopy} />}
                    </Button>
                  </InputRightElement>
                </InputGroup>
              </Box>

              <HStack justify="space-between" bg={hoverBg} p={4} rounded="lg">
                <VStack align="start" spacing={0}>
                  <Text fontSize="xs" color={subTextColor}>Network</Text>
                  <Text fontWeight="bold" color={textColor}>TRC20</Text>
                </VStack>
                <VStack align="end" spacing={0}>
                  <Text fontSize="xs" color={subTextColor}>Exchange Rate</Text>
                  <Text fontWeight="bold" color={currentService.color || "brand.500"}>
                    1 {currentService.currencyName} = {currentService.currencyPrice} INR
                  </Text>
                </VStack>
              </HStack>

              <Box w="100%">
                <Text mb={2} fontWeight="600" fontSize="sm" color={textColor}>Transaction ID</Text>
                <HStack>
                  <Input
                    ref={inputRef}
                    placeholder="Enter transaction hash/ID"
                    size="lg"
                    bg={inputBg}
                    border="1px solid"
                    borderColor={borderColor}
                    _focus={{ borderColor: currentService.color || "brand.500", boxShadow: `0 0 0 1px ${currentService.color || "var(--chakra-colors-brand-500)"}` }}
                  />
                  <Button
                    size="lg"
                    px={8}
                    onClick={handleTransaction}
                    bg={currentService.color || "brand.500"}
                    color="white"
                    _hover={{
                      transform: "translateY(-2px)",
                      shadow: "md",
                      filter: "brightness(1.1)"
                    }}
                    transition="all 0.2s"
                  >
                    Submit
                  </Button>
                </HStack>
              </Box>
            </VStack>
          )}
        </VStack>
      </Box>

      ===== END OF ORIGINAL UI ===== */}
    </VStack>
  )
}

export default Crypto